<template>
  <v-content>

 <v-card flat>
          <v-container
            fluid
            style="min-height: 0;"
            grid-list-lg
          >
            <v-layout row wrap>              
              <v-flex xs12 sm6 md3>
         
                  <v-card class="project_item green text-xs-center">
                 
                    <v-btn class="text-xs-center" @click="ShowFiltered('All')"> Kaikki  </v-btn>
                    <!-- <h4 class="white--text">yhteensä asiakkaat : {{total_pending_orders}}</h4> -->
                  </v-card>
           
              </v-flex>
              <v-flex xs12 sm6 md3>
     
                  <v-card class="project_item green text-xs-center" >
                    <!-- <h1 class="white--text">	Hyväksytty</h1> -->
                    <v-btn class="text-xs-center" @click="ShowFiltered('Bekleniyor')"> Odottaa  </v-btn>
                    <!-- <h4 class="white--text">yhteensä tilauksia : {{total_processing_orders}}</h4> -->
                  </v-card>
           
              </v-flex>
               <v-flex xs12 sm6 md3>
           
                  <v-card class="project_item green text-xs-center" >
                       <v-btn class="text-xs-center" @click="ShowFiltered('Onaylandı')"> Hyväksytty  </v-btn>
                    <!-- <h1 class="white--text">Hyväksytty</h1> -->
                    <!-- <h4 class="white--text">yhteensä tilauksia : {{total_complete_orders}}</h4> -->
                  </v-card>
        
              </v-flex>
              <v-flex xs12 sm6 md3>
              
                  <v-card class="white--text project_item green text-xs-center">
                    <v-btn class="text-xs-center" @click="ShowFiltered('Reddedildi')"> Peruutettu  </v-btn>
                    <!-- <h1 class="white--text">peruutettu</h1> -->
                    <!-- <h4 class="white--text">yhteensä tilauksia : {{total_cancelled_orders}}</h4> -->
                  </v-card>
         
              </v-flex>             
            </v-layout>
          </v-container>
        </v-card>

    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Etsi Asiakas"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="customers"
      :search="search"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      row
      wrap
      class="elevation-1 mx-3"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left"><router-link :to="{ name: 'ViewCustomer', params: {id:props.item.id} }">{{props.item.lname}}</router-link></td>
        <td class="text-xs-left">{{ props.item.fname }}</td>
        <td class="text-xs-left">{{ props.item.email }}</td>
        <td class="text-xs-left">{{ props.item.phone }}</td>       
        <td class="text-xs-left">{{ props.item.city }}</td>   
         <td class="text-xs-left">{{ props.item.status }}</td>       
        <td class="text-xs-left">{{ props.item.timestamp }}</td>      
        <v-btn fab dark small color="pink" @click="removeCustomer(props.item.id)">
           <v-icon dark>remove</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-content>
</template>

<script>
  import firebase from "firebase";
  import moment from 'moment'
  export default {
    name:'ShowCustomers',
    components: {

    },
    data(){
      return{
        search: '',
        customers:[],
        rowsPerPageItems: [8, 16, 24],
        pagination: {
        rowsPerPage: 8
        },
        headers: [
             { text: 'yhtiö', value: 'customer_name', sortable: !1 },
        { text: 'asiakas', value: 'customer_name', sortable: !1 },     
        { text: 'sähköpostiosoite' , value: 'email', sortable: !1 },
        { text: 'puhelinnumero' , value: 'phone', sortable: !1 },        
        { text: 'kaupunki' , value: 'city', sortable: !1 },      
        { text: 'tila' , value: 'status', sortable: !1 },  
        { text: 'luotu' , value: 'created', sortable: !1 },
        { text: 'toiminta' , value: 'action',sortable: !1 },
      ]
      }
    },
    methods:{
      removeCustomer(id){
        var db = firebase.firestore();

        // Remove from database
        var result = confirm("Want to delete?");
        if (result) {
          db.collection('profiles').doc(id).delete().then(() => {
            this.customers = this.customers.filter(customer => {
              return customer.id != id
            })
          })
        }  
      },
       ShowFiltered(param){

console.log("param:"+param)

             this.customers=[];
       var db = firebase.firestore();
      // Show All Customers
      let ref = db.collection('profiles').orderBy('timestamp', 'desc')    
      ref.onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if(change.type == 'added'){
            let doc = change.doc


                   if(param=='All')
            {
            let statusX='Odottaa'
          if(doc.data().status=='Bekleniyor')
        statusX='Odottaa'
          if(doc.data().status=='Onaylandı')
        statusX='Hyväksytty'
             if(doc.data().status=='Reddedildi')
        statusX='Peruutettu'

     

            this.customers.push({
              id:doc.id,
              name:doc.data().name,
              fname:doc.data().firstname,
              lname:doc.data().lastname,
              email:doc.data().email,
              phone:doc.data().phone,
              status:statusX,             
              city:doc.data().city,              
              timestamp:moment(doc.data().timestamp).format('ll')
            })
            }
            else if(doc.data().status==param)
            {
            let statusX='Odottaa'
          if(doc.data().status=='Bekleniyor')
        statusX='Odottaa'
          if(doc.data().status=='Onaylandı')
        statusX='Hyväksytty'
             if(doc.data().status=='Reddedildi')
        statusX='Peruutettu'

     

            this.customers.push({
              id:doc.id,
              name:doc.data().name,
              fname:doc.data().firstname,
              lname:doc.data().lastname,
              email:doc.data().email,
              phone:doc.data().phone,
              status:statusX,             
              city:doc.data().city,              
              timestamp:moment(doc.data().timestamp).format('ll')
            })
            }

          }
        })
      })   
    }
    },
    created(){
      var db = firebase.firestore();
      // Show All Customers
      let ref = db.collection('profiles').orderBy('timestamp', 'desc')    
      ref.onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if(change.type == 'added'){
            let doc = change.doc

            let statusX='Odottaa'
          if(doc.data().status=='Bekleniyor')
        statusX='Odottaa'
          if(doc.data().status=='Onaylandı')
        statusX='Hyväksytty'
             if(doc.data().status=='Reddedildi')
        statusX='Peruutettu'

            this.customers.push({
              id:doc.id,
              name:doc.data().name,
              fname:doc.data().firstname,
              lname:doc.data().lastname,
              email:doc.data().email,
              phone:doc.data().phone,
              status:statusX,             
              city:doc.data().city,              
              timestamp:moment(doc.data().timestamp).format('ll')
            })

     

          }
        })
      })
    },   
  }
</script>

<style>
tbody a{
  font-size: 13px;
  color:black;
  text-decoration: underline;
}
.text-xs-right{
  text-align: left !important;
}
td{
  text-align: center;
}
.primary--text {
  color: #345B2C !important;
  caret-color: #345B2C !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/customers/ShowCustomers.vue